import smoothscroll from 'smoothscroll-polyfill';
 
// kick off the polyfill!
smoothscroll.polyfill();

function doScrolling(element, duration, parent) { 
    return new Promise((resolve, reject) => {
        if (!element) reject();
        const elem = document.querySelector(element);

        if (parent) {
            const parentElem = document.querySelector(parent);
            parentElem.scroll({ top: 0, left: 0, behavior: 'smooth' });
        } else {
            elem.scrollIntoView({ behavior: 'smooth' })
        }

        setTimeout(resolve, 400);
    })
}




export default doScrolling;